import * as React from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';

interface Props {
  chiave: string;
  valore: string | number | undefined | null;
  popoverMessage?: string | undefined | null;
  isValueHighlighed?: boolean | undefined | null;
}

const Riepilogo: React.VFC<Props> = (props: Props) => {

  const {
    chiave,
    valore,
    popoverMessage,
    isValueHighlighed
  } = props;


  const popoverFocus = (
    <Tooltip id="popover-trigger-focus" title="Popover bottom">
      {popoverMessage || ""}
    </Tooltip>
  );

  return (
    <>
      {(popoverMessage && popoverMessage.length > 0) &&
        (
          <OverlayTrigger
            placement="bottom-end"
            delay={{ show: 250, hide: 400 }}
            overlay={popoverFocus}>
            <Button variant="link" style={{ padding: "0", paddingRight: "2px" }}><i className="fas fa-info-circle"></i></Button>
          </OverlayTrigger>
        )}

      <span className="font-weight-bold">{chiave}: </span>
      {(isValueHighlighed || false) ? (<span style={{ fontWeight: 'bold', textDecoration: 'underline' }}>{valore || '-'}</span>) : (<span>{valore || '-'}</span>)}
    </>
  );
}

export default Riepilogo;
